module.exports = __webpack_public_path__ + "img/8.7f8eb820.png";